import { useState, useEffect } from "react";
import ManagedEquipement from "./ManagedEquipement";
import { useDispatch, useSelector } from 'react-redux';
import { setOrderData } from "Store/Component/BulkOrder/BulkOrderAction";
import { CONSTANTS } from "client/utils/constants";
import { commonDropDownSelectionChange } from "utils";

const ManagedEquipementsContainer = (props: any) => {
  const { vehicle, managedEquipRef } = props

  const dispatch = useDispatch();

  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [SizeDropDownList, setSizeDropDownList] = useState<any>([]);
  const [TypeDropDownList, setTypeDropDownList] = useState<any>([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState<any>([]);
  const [StyleDropDownList, setStyleDropDownList] = useState<any>([]);
  const [lengthDropDownList, setLengthDropDownList] = useState<any>([]);
  const [fuelTankDropDownList, setFuelTankDropDownList] = useState<any>([]);
  const [chargingStationDropdownList, setChargingStationDropdownList] = useState<any>([]);
  

  const { orderDetails }: any = useSelector((state?: any) => ({
    orderDetails: state.BulkOrderReducer.orderDetails
  }));

  ///Modified dropDown values as required
  useEffect(() => {
    let dropdownList:any =  vehicle?.searchDropdowns?.length ? JSON.parse(JSON.stringify(vehicle?.searchDropdowns)) : []
    if (dropdownList?.length > 0) {
      dropdownList?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultCategoryOption = {
            text: "Select Category",
            value: null
          };
          item?.dropdownList?.unshift(defaultCategoryOption);
          let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        } else if (item?.dropdownName == "Size" && vehicle?.selectedEquipementType?.text === CONSTANTS.SNOW) {
          const defaultSizeOption = {
            text: "Select Size",
            value: null
          };
          item?.dropdownList?.unshift(defaultSizeOption);
          let sizeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setSizeDropDownList(sizeDropdownListTemp)
        } else if (item?.dropdownName == "Type" && vehicle?.selectedEquipementType?.text === CONSTANTS.SNOW) {
          const defaultTypeOption = {
            text: "Select Type",
            value: null
          };
          item?.dropdownList?.unshift(defaultTypeOption);
          let typeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setTypeDropDownList(typeDropdownListTemp)
        } else if (item?.dropdownName == "Style") {
            const defaultStyleOption = {
              text: "Select Style",
              value: null
            };
            item?.dropdownList?.unshift(defaultStyleOption);
            let styleDropdownListTemp = item?.dropdownList?.map((val: any) =>
              ({ text: val.text, value: val.value, label: val.text, key: val.value })
            );
            setStyleDropDownList(styleDropdownListTemp)
        } else if (item?.dropdownName == "Length") {
            const defaultLengthOption = {
              text: "Select Length",
              value: null
            };
            item?.dropdownList?.unshift(defaultLengthOption);
            let lengthDropdownListTemp = item?.dropdownList?.map((val: any) =>
              ({ text: val.text, value: val.value, label: val.text, key: val.value })
            );
            setLengthDropDownList(lengthDropdownListTemp)
          }else if (item?.dropdownName == "Fuel Tank") {
            const defaultFuelTankOption = {
              text: "Select Fuel Tank",
              value: null
            };
            item?.dropdownList?.unshift(defaultFuelTankOption);
            let fuelTankDropdownListTemp = item?.dropdownList?.map((val: any) =>
              ({ text: val.text, value: val.value, label: val.text, key: val.value })
            );
            setFuelTankDropDownList(fuelTankDropdownListTemp)
          } else if (item?.dropdownName == "Charging Station") {
            const defaultChargingStationOption = {
              text: "Select Charging Station",
              value: null
            };
            item?.dropdownList?.unshift(defaultChargingStationOption);
            let chargingStationDropdownListTemp = item?.dropdownList?.map((val: any) =>
              ({ text: val.text, value: val.value, label: val.text, key: val.value })
            );
            setChargingStationDropdownList(chargingStationDropdownListTemp)
        }
      })
    }
  }, [vehicle?.searchDropdowns])

  const handleSelectionChange = (e: any, item: any, name: string, nextField: number) => {
    let globalValues = {
      orderDetails: orderDetails,
      vehicle: vehicle,
      dispatch: dispatch,
    }
    commonDropDownSelectionChange(item, name, nextField, globalValues, setOrderData, managedEquipRef)
  }

  useEffect(() => {
    managedEquipRef.current[1]?.focus()
  }, [])

  return (
      <ManagedEquipement
          managedEquipmentValues={vehicle?.searchCriteria}
          manufacturerDropDownList={manufacturerDropDownList}
          categoryDropdownList={categoryDropdownList}
          TypeDropDownList={TypeDropDownList}
          SizeDropDownList={SizeDropDownList}
          StyleDropDownList={StyleDropDownList}
          lengthDropDownList={lengthDropDownList}
          fuelTankDropDownList={fuelTankDropDownList}
          chargingStationDropdownList={chargingStationDropdownList}
          managedEquipRef={managedEquipRef}
          handleSelectionChange={handleSelectionChange}
          type={vehicle?.selectedEquipementType?.text}
      />
  )
}

export default ManagedEquipementsContainer;
